
import { Component, Prop, Vue } from 'nuxt-property-decorator'

@Component
export default class QuizGridItem extends Vue {
  @Prop({
    required: true,
    default: '',
    type: String,
  })
  private readonly title!: string

  @Prop({
    required: true,
    default: '',
    type: String,
  })
  private readonly iconUrl!: string

  get iconStyle () {
    return {
      backgroundImage: `url(${this.iconUrl})`,
    }
  }
}
